import React from "react";
import { useIntl } from "react-intl";
import { ArrowUp } from "@piiqtechnologies/svg-icons";
import { PeekChip, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import messages from "./messages.i18n";
export const CategoryCardStatusChip = ({ categoryChange, isCategoryReviewPositive, }) => {
    const intl = useIntl();
    if (!categoryChange)
        return React.createElement(React.Fragment, null);
    const colorVariant = isCategoryReviewPositive ? "success" : "error";
    return (React.createElement(PeekChip, { size: "small", sx: {
            color: `${colorVariant}.main`,
            "&.MuiChip-filledDefault": { backgroundColor: `${colorVariant}.light` },
        }, variant: "filled", label: React.createElement(PeekStack, { direction: "row", alignItems: "center" },
            React.createElement(ArrowUp, { style: { transform: isCategoryReviewPositive ? "none" : "rotate(180deg)" }, color: `${colorVariant}.main` }),
            React.createElement(PeekTypography, null, intl.formatMessage(messages.categoryCardStatusChipLabel, { change: categoryChange }))) }));
};
export default CategoryCardStatusChip;
